<template>
  <div class='table-box'>
    <global-tag>
      <el-form label-width='100px'>
        <el-row>
          <el-col :span='5'>
            <el-form-item label='字典类型：'>
              <el-input
                v-model='typeId'
                placeholder='请输入字典类型'
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='5' :offset='4'>
            <el-button
              type='primary'
              icon='el-icon-search'
              @click='search'
            >搜索
            </el-button
            >
            <el-button
              type='info'
              icon='el-icon-delete'
              @click='handleReset'
            >清除条件
            </el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </global-tag>
    <div class='table_title' style='margin: 24px 0'>
      <el-button
        type='success'
        icon='iconfont icon-xinzeng'
        @click="handleTableForm('新增')"
      >新增
      </el-button
      >
      <!-- <div class="screen_container" style="width: 100%;margin-top:24px;text-align: right;">
<el-button-group>
  <el-button type="primary" icon="el-icon-refresh" @click="Reset"></el-button>
  <el-button type="primary" style="padding: 10px 20px">
    <el-dropdown trigger="click" :hide-on-click="false">
      <span class="el-dropdown-link">
        <i class="el-icon-s-grid el-icon--right" style="color: #fff"></i>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown" class="table_checkbox">
        <el-dropdown-item>
          <el-checkbox-group
            v-model="tableChekbox"
            @change="tableChekboxChange"
          >
            <el-checkbox label="序号"></el-checkbox><br/>
            <el-checkbox label="字典类型"></el-checkbox><br/>
            <el-checkbox label="字典id"></el-checkbox><br/>
            <el-checkbox label="字典名称"></el-checkbox><br/>
            <el-checkbox label="排序"></el-checkbox><br/>
            <el-checkbox label="状态"></el-checkbox><br/>
            <el-checkbox label="操作"></el-checkbox>
          </el-checkbox-group>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-button>
</el-button-group>
</div> -->
    </div>
    <!-- tableb表格 -->
    <div class='table_container'>
      <el-table
        :data='tableData'
        tooltip-effect='dark'
        style='width: 100%'
        height='550px'
        :header-cell-style="{
                        background: '#e6e6e6',
                        color: '#000',
                    }"
        border
      >
        <el-table-column
          width='80'
          align='center'
          label='序号'
          type='index'
          v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '序号'
                            ) != -1
                        "
        >
        </el-table-column>
        <el-table-column
          align='center'
          label='字典类型'
          prop='typeId'
          v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '字典类型'
                            ) != -1
                        "
        >
        </el-table-column>
        <el-table-column
          align='center'
          label='字典id'
          prop='dictId'
          v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '字典id'
                            ) != -1
                        "
        >
        </el-table-column>
        <el-table-column
          align='center'
          label='字典名称'
          prop='dictName'
          v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '字典名称'
                            ) != -1
                        "
        >
        </el-table-column>
        <el-table-column
          align='center'
          label='排序'
          prop='orders'
          v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '排序'
                            ) != -1
                        "
        >
        </el-table-column>
        <el-table-column
          align='center'
          label='状态'
          prop='status'
          v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '状态'
                            ) != -1
                        "
        >
          <template slot-scope='scope'>
                            <span>{{
                                scope.row.status == 1 ? '禁用' : '启用'
                              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label='操作'
          align='center'
          width='140px'
          v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '操作'
                            ) != -1
                        "
        >
          <template slot-scope='scope'>
            <el-tooltip
              effect='dark'
              content='编辑'
              placement='top-start'
            >
              <img
                src='./assets/img/table_edit.png'
                @click="handleTableForm('编辑', scope.row)"
                style='margin-left: 12px; cursor: pointer'
              />
            </el-tooltip>
            <el-tooltip
              class='item'
              effect='dark'
              content='删除'
              placement='top-start'
            >
              <img
                src='./assets/img/table_delete.png'
                @click='handleDelete(scope.row)'
                style='margin-left: 12px; cursor: pointer'
              />
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class='pagination_container'>
      <el-pagination
        layout='total, sizes, prev, pager, next, jumper'
        :page-size='pageSize'
        :total='total'
        :current-page.sync='pageNo'
        @size-change='handletableDataSize'
        @current-change='handleTableDataChange'
      ></el-pagination>
    </div>
    <el-dialog
      :title='dialogVisibleTitle'
      :visible.sync='dialogVisible'
      width='40%'
      class='dialog_container'
      @close='dialogVisibleClone'
    >
      <div class='dialog_content'>
        <el-form
          label-width='120px'
          :model='formData'
          :rules='formDataRules'
          ref='formData'
        >
          <el-form-item label='字典类型：' prop='typeId'>
            <el-input
              v-model.trim='formData.typeId'
              placeholder='请输入字典类型'
            ></el-input>
          </el-form-item>
          <el-form-item label='字典id：' prop='dictId'>
            <el-input
              v-model.number='formData.dictId'
              placeholder='请输入字典id'
            ></el-input>
          </el-form-item>
          <el-form-item label='字典名称：' prop='dictName'>
            <el-input
              v-model.trim='formData.dictName'
              placeholder='请输入字典名称'
            ></el-input>
          </el-form-item>
          <el-form-item label='排序：' prop='orders'>
            <el-input
              v-model.number='formData.orders'
              placeholder='请输入排序'
            ></el-input>
          </el-form-item>
          <el-form-item label='状态：' prop='status'>
            <el-radio-group v-model='formData.status'>
              <el-radio label='0'>启用</el-radio>
              <el-radio label='1'>禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='handleSubmit'
                    >确 定</el-button
                    >
                    <el-button @click='dialogVisible = false'>取 消</el-button>
                </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AddressManagement',
  data() {
    return {
      typeId: '', //字典类型
      pageSize: 10,
      pageNo: 1,
      total: 0,
      formData: {
        typeId: '', //字典类型
        dictId: '', //字典id
        dictName: '', //字典名称
        orders: '', //排序
        status: '0' //状态
      },
      formDataRules: {
        typeId: [
          //字典类型
          {
            required: true,
            message: '字典类型不能为空',
            trigger: 'blur'
          }
        ],
        dictId: [
          //字典id
          {
            required: true,
            message: '字典id不能为空',
            trigger: 'blur'
          },
          {
            type: 'number',
            message: '字典id为数字值',
            trigger: 'blur'
          }
        ],
        dictName: [
          //字典名称
          {
            required: true,
            message: '字典名称不能为空',
            trigger: 'blur'
          }
        ],
        orders: [
          //排序
          {
            required: true,
            message: '排序不能为空',
            trigger: 'blur'
          },
          {
            type: 'number',
            message: '排序为数字值',
            trigger: 'blur'
          }
        ]
      },
      tempTableChekbox: [
        '序号',
        '字典类型',
        '字典id',
        '字典名称',
        '排序',
        '状态',
        '操作'
      ],
      tableChekbox: [
        '序号',
        '字典类型',
        '字典id',
        '字典名称',
        '排序',
        '状态',
        '操作'
      ],
      tableData: [
        // tabble数据
      ],
      dialogVisible: false, //table表单弹窗
      dialogVisibleTitle: '' //table表单弹窗title
    }
  },
  // inject: ["reload"], //注入
  mounted() {
  },
  created() {
    this.getFindList()
  },
  methods: {
    search() {
      this.getFindList()
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http
            .request({
              url: '/rbac/admin/dict/info/delete',
              method: 'POST',
              data: {
                id: row.id
              }
            })
            .then((res) => {
              if (res.code == 200) {
                this.$message.success('删除成功')
              } else if (res.code == '10004') {
                this.$message.error(res.message)
                this.$router.push('/login')
              } else {
                this.$message.error('删除失败')
              }
              this.getFindList()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    //获取表格数据
    getFindList() {
      this.$http
        .request({
          url: '/rbac/admin/dict/info/list',
          method: 'POST',
          data: {
            pageSize: this.pageSize,
            pageNo: this.pageNo,
            typeId: this.typeId
          }
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == 'null') {
              this.tableData = []
              this.total = 0
              return
            }
            this.tableData = res.content.list
            this.total = res.content.count
          } else if (res.code == '10004') {
            this.$message.error(res.message)
            this.$router.push('/login')
          }
        })
    },
    handleSubmit() {
      let url = ''
      if (this.dialogVisibleTitle == '新增') {
        url = '/rbac/admin/dict/info/insert'
      }
      if (this.dialogVisibleTitle == '编辑') {
        url = '/rbac/admin/dict/info/update'
      }
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.$http
            .request({
              url: url,
              method: 'POST',
              data: this.formData
            })
            .then((res) => {
              if (res.code == 200) {
                this.$message.success(
                  this.dialogVisibleTitle + '成功'
                )
                this.getFindList()
              } else if (res.code == '10004') {
                this.$message.error(res.message)
                this.$router.push('/login')
              } else {
                this.$message.error(
                  this.dialogVisibleTitle + '失败'
                )
              }
              this.dialogVisible = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //清除搜索条件
    handleReset() {
      this.pageSize = 10
      this.pageNo = 1
      this.typeId = ''
      this.getFindList()
    },
    handleTableForm(title, row) {
      this.dialogVisible = true
      this.dialogVisibleTitle = title
      if (title == '新增') return
      this.formData.typeId = row.typeId //字典类型
      this.formData.dictId = Number(row.dictId) //字典id
      this.formData.dictName = row.dictName //字典名称
      this.formData.orders = Number(row.orders) //排序
      this.formData.status = String(row.status) //状态
      if (title == '编辑') {
        this.formData.id = row.id
      }
    },
    // 页面刷新
    Reset() {
      this.reload()
    },
    //table列checkbox发生变化
    tableChekboxChange(val) {
      this.tempTableChekbox = val.map((item) => item)
    },
    //table表格表单弹窗关闭时事件
    dialogVisibleClone() {
      this.formData.typeId = '' //字典类型
      this.formData.dictId = '' //字典id
      this.formData.dictName = '' //字典名称
      this.formData.orders = '' //排序
      this.formData.status = '0' //状态
      delete this.formData.id
    },
    //老人信息列表pagesize发生改变
    handletableDataSize(val) {
      this.pageSize = val
      this.getFindList()
    },
    //老人信息列表页码发生改变
    handleTableDataChange(val) {
      this.pageNo = val
      this.getFindList()
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .dialog_container {
  .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
  }

  .el-dialog__body {
    padding-left: 60px;
    padding-right: 60px;
  }

  .dialog_content {
    .el-col {
      text-align: center;
    }

    .el-select {
      .el-input__inner {
        width: 100%;
      }
    }

    .table_add_wraoper {
      .add_table {
        margin-top: 24px;
      }
    }
  }

  .el-dialog__footer {
    background: #f5f5f5;
    padding: 8px 15px;
    border-top: 1px solid #e5e5e5;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}

.table_container {
  width: 100%;
}

.pagination_container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

/deep/ .el_main_container {
  padding: 20px 20px 42px 20px !important;
  background-color: #ffffff !important;
  height: calc(100vh - 60px);
  overflow-y: auto;
  padding: 0;
  background-color: rgba(242, 242, 242, 1);

  &.active {
    padding: 0 !important;
  }

  .table_title {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .btn_group {
      margin-top: 42px;
    }
  }

  // table_add_wraoper
  /deep/ .dialog_container {
    .el-dialog__header {
      border-bottom: 1px solid #e5e5e5;
    }

    .el-dialog__body {
      padding-left: 60px;
      padding-right: 60px;
    }

    .dialog_content {
      .el-col {
        text-align: center;
      }

      .el-select {
        .el-input__inner {
          width: 100%;
        }
      }

      .table_add_wraoper {
        .add_table {
          margin-top: 24px;
        }
      }
    }

    .el-dialog__footer {
      background: #f5f5f5;
      padding: 8px 15px;
      border-top: 1px solid #e5e5e5;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }

  .table_container {
    margin-top: 12px;
  }
}
</style>
